/**
 * @generated SignedSource<<3db325c39d25b6d3dbb13496be6a0dfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditLinkProductMutation$variables = {
  employeeId?: string | null;
  productId: string;
  todoId: string;
};
export type TodoEditLinkProductMutation$data = {
  readonly todo: {
    readonly linkProduct: {
      readonly id: string;
      readonly linkedProducts: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type TodoEditLinkProductMutation = {
  response: TodoEditLinkProductMutation$data;
  variables: TodoEditLinkProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "employeeId",
        "variableName": "employeeId"
      },
      {
        "kind": "Variable",
        "name": "todoId",
        "variableName": "todoId"
      }
    ],
    "concreteType": "TodoMutation",
    "kind": "LinkedField",
    "name": "todo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "productId",
            "variableName": "productId"
          }
        ],
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "linkProduct",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditLinkProductMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditLinkProductMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "947adff5406eda8147e715e8298e9cd9",
    "id": null,
    "metadata": {},
    "name": "TodoEditLinkProductMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditLinkProductMutation(\n  $todoId: ID!\n  $productId: ID!\n  $employeeId: ID\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    linkProduct(productId: $productId) {\n      id\n      linkedProducts {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7538061e664c3d3a3d3eade0a730ce33";

export default node;
